/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';

export interface FindByName_1$Params {
  name: string;
}

export function findByName_1(http: HttpClient, rootUrl: string, params: FindByName_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerHatchery>>> {
  const rb = new RequestBuilder(rootUrl, findByName_1.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerHatchery>>;
    })
  );
}

findByName_1.PATH = '/api/customer/hatchery/name/{name}';
